import { isObject } from 'shared/utils/object';

export function keepUndeleted<T extends { deleted: boolean }>(
  element: T
): boolean {
  return !element.deleted;
}

export function isNotDeleted<T>(
  value: unknown
): value is T {
  if (!isObject<{ deleted?: unknown }>(value)) {
    return false;
  }

  return value.deleted !== true;
}
